import { createOpenStore, type ColumnDialogOpen } from "stores/createOpenStore";

export const useSplitColumnStore = createOpenStore<ColumnDialogOpen>();
